import {
  Radio as AriaRadio,
  RadioProps as AriaRadioProps,
} from 'react-aria-components';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface RadioProps extends AriaRadioProps {}

export function Radio({ ...props }: RadioProps) {
  return <AriaRadio {...props} />;
}
